<template>
  <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-16 px-4 sm:px-0">
      <div class="flex items-center">
        <div class="flex-shrink-0">
          <img class="h-8 w-8" src="/images/studio.svg" alt="St. Audio Studio" />
        </div>
        <div class="ml-6 flex items-baseline space-x-4 text-gray-300">
          St. Audio Studio
        </div>
      </div>
      <div class="hidden md:block">
        <div class="ml-4 flex items-center md:ml-6">
          <ActionButton @click="onLogout">
            <span class="mr-3">
              Logout
            </span>
            <ArrowRightOnRectangleIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </ActionButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();

const onSuccess = () =>
{
  console.log("Logout successful");
  router.push({ name: "login" });
};

const onFailure = () =>
{
  console.log("Logout failed");
  router.push({ name: "login" });
};

const onLogout = () =>
{
  store.dispatch('auth/logout')
  .then(result => onSuccess(result))
  .catch(error => onFailure(error));
};
</script>
